namespace RedBullMOBILE360.CustomerCare {
    @Serenity.Decorators.registerClass()
    export class ThreeThreeZeroNotificationExcelImportDialog extends Serenity.PropertyDialog<any, any>  {
        private form: ThreeThreeZeroNotificationExcelImportForm;
        public IsDataImported: boolean = false;

        constructor() {
            super();
            this.form = new ThreeThreeZeroNotificationExcelImportForm(this.idPrefix);

        }
        protected getFormKey() {
            return ThreeThreeZeroNotificationExcelImportForm.formKey;
        }

        protected getDialogTitle(): string {
            return "Import Data";
        }

        protected getDialogButtons() {
            let buttons = [];
            buttons.push({
                text: 'Import',
                cssClass: 'export-xlsx-button',
                click: () => {
                    if (!this.validateBeforeSave())
                        return;

                    if (this.form.FileName.value == null ||
                        Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                        Q.notifyError("Please select a file!");
                        return;
                    }

                    ThreeThreeZeroNotificationService.ExcelImport({
                        FileName: this.form.FileName.value.Filename
                    }, (response) => {
                        let messageParts = new Array<string>();
                        if (response.Inserted > 0) messageParts.push("Data Saved Successfully: " + response.Inserted);
                        if (response.Updated > 0) messageParts.push("<span style='color: red;'>Failed: " + response.Updated) + "</span>";
                        response.ErrorList.forEach((val) => {
                            messageParts.push(val);
                        });

                        let message: string = messageParts.join("\n");

                        Q.information(message, () => {
                        }, {
                            htmlEncode: false
                        });

                        this.IsDataImported = true;

                        this.dialogClose();
                    });
                },
            });
            buttons.push(
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            );
            return buttons;
        }


    }
}